import { render } from "./McpServerCarousel.vue?vue&type=template&id=1cd097cb&scoped=true&ts=true"
import script from "./McpServerCarousel.vue?vue&type=script&lang=ts"
export * from "./McpServerCarousel.vue?vue&type=script&lang=ts"

import "./McpServerCarousel.vue?vue&type=style&index=0&id=1cd097cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd097cb"]])

export default __exports__